import { BaseRouteService } from 'core/services';

class OrderLineRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'order-lines/';
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	get(id, options) {
		return super.get(this.base + '{id}/{?embed}', id, options);
	}

	linkOrderLine(sourceOfChange) {
		return super.create(this.base + 'link-order-line/?sourceOfChange={sourceOfChange}', {sourceOfChange});
	}

	linkAllOrderLines(sourceOfChange) {
		return super.update(this.base + 'link-order-lines/?sourceOfChange={sourceOfChange}', {sourceOfChange});
	}
}

export default OrderLineRouteService;
